import { ElasticSearchFacetCounts } from 'types/commons';
import { FormattedOption } from 'types/dictionaries';

export const mapOptionsWithLabels = (
  options: FormattedOption[],
  facets?: ElasticSearchFacetCounts
): FormattedOption[] => {
  if (!facets) return options;

  return options.map((option) => {
    const baseLabel =
      option.filterLabel ??
      (typeof option.label === 'string' ? option.label : '');
    return {
      ...option,
      label: facets[option.value]
        ? `${baseLabel} (${facets[option.value]})`
        : option.label
    };
  });
};
